














































































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { FormState } from '@/components/prine/enums/FormState';
import DetailedConfirmModal from '@/components/prine/DetailedConfirmModal.vue';

import type { Tag } from '@/models/tag';
import type { User } from '@/models/user';
import { tagWebservice } from '@/webservices/tag';
import PrineButton from '@/components/prine/PrineButton.vue';
import { hasPermission } from '@/helpers/auth/permissionHelpers';
import { PERMISSIONS } from '@/helpers/auth/permissions';

@Component({
    name: 'StoreUpdateTag',
    computed: {
        PERMISSIONS() {
            return PERMISSIONS;
        },
    },
    methods: { hasPermission },
    components: {
        DetailedConfirmModal,
        PrineButton,
    },
})
export default class StoreUpdateTag extends Vue {
    public FormState = FormState;

    // Data
    protected disabled: boolean = false;
    protected errorMsg: string = '';
    protected isConfirmModalActive: boolean = false;
    protected state: FormState = FormState.New;

    protected tag: Tag = {} as Tag;
    protected loading = {
        data: false,
        color: '#fdc05d',
        size: '40px',
    };

    protected affectedData: Map<string, number> = new Map();

    @Getter('account/userInfo') private userInfo: User;

    // Mounted is called initially
    private mounted() {
        if (this.$route.query.hasOwnProperty('tagId')) {
            this.load(Number.parseInt(this.$route.query.tagId.toString(), 10));
            this.state = FormState.Update;
        } else {
            // Initialize the default with false, if it's a new
            this.tag.default = false;
        }
    }

    private load(tagId: number) {
        this.loading.data = true;
        tagWebservice.getById(tagId).then((response) => {
            this.tag = response.data;
            this.loading.data = false;
            this.affectedData.set(this.$tc('keywords.lesson', 2).toString(), this.tag.lessons_count);
        });
    }

    private save() {
        this.disabled = true;
        const self = this;
        if (!this.validate()) {
            this.disabled = false;
            return 0;
        }

        if (this.state === FormState.New) {
            tagWebservice
                .store(this.tag)
                .then((response) => {
                    this.$buefy.toast.open({
                        duration: 3000,
                        message: this.$t('toastMessages.store.tag').toString(),
                        type: 'is-success',
                    });
                    this.$router.push({ path: '/knowledge/tags' });
                })
                .catch((error) => {
                    this.disabled = false;
                    console.log(error);
                });
        } else if (this.state === FormState.Update) {
            tagWebservice
                .update(this.tag)
                .then((response) => {
                    this.$buefy.toast.open({
                        duration: 3000,
                        message: this.$t('toastMessages.update.tag').toString(),
                        type: 'is-success',
                    });
                    this.$router.push({ path: '/knowledge/tags' });
                    this.disabled = false;
                })
                .catch((error) => {
                    this.disabled = false;
                    console.log(error);
                });
        }
    }

    private toggleConfirmModal(answer) {
        this.isConfirmModalActive = !this.isConfirmModalActive;
        if (answer === true) {
            this.remove();
        }
    }

    private remove() {
        const self = this;
        tagWebservice
            .remove(this.tag)
            .then((response) => {
                this.$buefy.toast.open({
                    duration: 3000,
                    message: this.$t('toastMessages.delete.tag').toString(),
                    type: 'is-success',
                });
                this.$router.push({ path: '/knowledge/tags' });
            })
            .catch((error) => {
                console.log(error);
            });
    }

    private validate() {
        if (!this.tag.title || this.tag.title === '') {
            this.errorMsg = 'title';
            return 0;
        } else {
            return true;
        }
    }
}
